import React from "react";
import "./EarningsTable.css";

const EarningsTable = ({ transactions }) => {
  return (
    <div className="earnings-table">

      <div className="table-header">
        <h2>Recent Transactions</h2>
        <p>
          List of completed orders and earnings
        </p>
      </div>

      <div className="table-responsive">

        <table>

          <thead>

            <tr>
              <th>#</th>
              <th>Customer</th>
              <th>Order ID</th>
              <th>Payment</th>
              <th>Total</th>
              <th>Commission</th>
              <th>Your Earnings</th>
              <th>Settlement</th>
              <th>Status</th>
              <th>Date</th>
            </tr>

          </thead>

          <tbody>

            {transactions.length === 0 ? (

              <tr>

                <td
                  colSpan="10"
                  className="no-data"
                >
                  No Transactions Found
                </td>

              </tr>

            ) : (

              transactions.map(
                (item, index) => (

                  <tr key={item._id}>

                    <td>{index + 1}</td>

                    <td>
                      {item.customer?.name ||
                        "Customer"}
                    </td>

                    <td>
                      {item.order?._id
                        ?.slice(-8)
                        .toUpperCase()}
                    </td>

                    <td>
                      {item.paymentMethod}
                    </td>

                    <td>
                      ₹
                      {item.totalAmount.toLocaleString()}
                    </td>

                    <td className="commission">
                      ₹
                      {item.platformCommission.toLocaleString()}
                    </td>

                    <td className="earning">
                      ₹
                      {item.providerEarning.toLocaleString()}
                    </td>

                    <td>

                      <span
                        className={`settlement ${item.settlementStatus.toLowerCase()}`}
                      >
                        {item.settlementStatus}
                      </span>

                    </td>

                    <td>

                      <span
                        className={`status ${item.paymentStatus.toLowerCase()}`}
                      >
                        {item.paymentStatus}
                      </span>

                    </td>

                    <td>
                      {new Date(
                        item.createdAt
                      ).toLocaleDateString()}
                    </td>

                  </tr>
                )
              )

            )}

          </tbody>

        </table>

      </div>

    </div>
  );
};

export default EarningsTable;